<template>
  <div>
    <header class="header_area headroom">
      <div class="container-fluid bg-color" style="width: 100% !important">
        <vs-row class="vx-row align-items-center">
          <!-- Menu Area Start -->
          <vs-col class="vx-col" vs-w="12">
            <div class="menu_area">
              <nav
                class="navbar navbar-expand-xl px-1"
                :class="{ 'navbar--hidden': !showNavbar }"
              >
                <!-- Logo -->

                <logo class="w-10 mr-4 fill-current text-primary" />
                <h4 class="logo-font mt-2 ml-1">DHP Admin</h4>
                <vs-button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#ca-navbar"
                  aria-controls="ca-navbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </vs-button>
                <!-- Menu Area -->
                <div class="collapse navbar-collapse" id="ca-navbar">
                  <ul class="navbar-nav ml-auto" id="nav">
                    <!-- <li
                      class="nav-item nav-link px-3"
                      @click="$router.push('/pages/login')"
                    >
                      Login
                    </li>
                    
                   
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#demos"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Demos</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#features"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Features</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#applications"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Apps</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#cards"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Cards</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#pages"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Pages</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link px-3"
                        href="#components"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        >Components</a
                      >
                    </li> -->
                    <li class="nav-item buynow-btn">
                      <!-- Login -->
                      <a
                        class="nav-link px-4"
                        href=""
                        v-on:click.prevent="$router.push('/pages/login')"
                        >Login</a
                      >
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </header>
    <!-- ***** Header Area End ***** -->
    <!-- ***** Welcome Area Start ***** -->
    <section class="wellcome_area" id="home">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col-lg-5 col-md ">
            <div class="wellcome-heading">
              <h2 class="m-0">
                Digital Health Passport
                <span class="no-bold"><i>Admin</i></span>
              </h2>

              <ul class="dhp-ul">
                <li>Manage Digital Health Passport app</li>
                <li>Generate Health Hacks content</li>
                <li>Manage Users</li>
                <li>Send Push Notification</li>
                <li>Update app content page like About, Privacy Policy etc</li>
              </ul>
            </div>
          </div>
          <div
            class="col-lg-7 col-sm-12 order-1 order-xl-2 full-xl wow fadeInDown pr-0"
          >
            <!-- <div class="row justify-content-center mb-5">
              <a
                class="btn demo-btn mr-3"
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/landing/"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                data-original-title="Vuexy Vue.js & Vue + Laravel Version"
              >
                <img
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/vue-icon.png"
                  width="22"
                  alt="icons"
                />
                Vue JS
              </a>
              <a
                class="btn demo-btn-light mr-3"
                href="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                data-original-title="Vuexy HTML & HTML + Laravel Version"
              >
                <img
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/html-icon.png"
                  class="align-top"
                  width="22"
                  alt="icons"
                />
                HTML
              </a>
              <a
                class="btn demo-btn-light"
                href="https://pixinvent.com/demo/vuexy-react-admin-dashboard-template/landing/"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                data-original-title="Vuexy React.js Version"
              >
                <img
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/react-icon.png"
                  class="align-top"
                  width="22"
                  alt="icons"
                />
                React JS
              </a>
            </div> -->
            <div class="row">
              <div
                class="col-12 flex justify-content-center align-items-center"
              >
                <!-- <figure class="cd-image-container float-r-lg">
                  <a
                    href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-2/dashboard/analytics"
                    target="_blank"
                    > -->
                <img
                  class="dhp_logo"
                  src="@/assets/images/logo/DHP_Logo_no_text.png"
                  alt="Logo"
                />
                <div class="">
                  <h1 class="m-0 color-white">Digital</h1>
                  <h1 class="m-0 color-white">Health</h1>
                  <h1 class="m-0 color-white">Passport</h1>
                </div>
                <div class="app-link">
                   <a
                    href=""
                    target="_blank"
                    > 
                  <img src="@/assets/images/landing/Google-Play.svg" alt="" />
                   </a>
                    <a
                    href=""
                    target="_blank"
                    > 
                  <img src="@/assets/images/landing/App-Store.svg" alt="" />
                    </a>
                </div>
                <!-- </a>
                  <span class="cd-image-label" data-type="original"></span> -->
                <!-- <div class="cd-resize-img">
                  <a class="btn btn-secondary btn-sm" href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/dashboard/analytics" target="_blank"><img src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/bg-img/light.jpg" alt="Original Image" /></a>
                  <span class="cd-image-label" data-type="modified"></span>
                </div> -->
                <!-- <span
                    class="cd-handle"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Drag me"
                  ></span>
                </figure> -->
                <!-- cd-image-container -->
              </div>
            </div>
          </div>
        </div>
        
        <!-- <a
          class="btn hire-us"
          href="https://goo.gl/forms/VyFbfVnmjNeydq0Y2"
          target="_blank"
          ><span
            ><span class="ti-user mr-1 align-middle font-900"></span> Hire
            Us</span
          ></a -->
        
      </div>
    </section>
    <!-- ***** Welcome Area End ***** -->
    <!-- ***** Demos ***** -->
    <!-- <section class="bg-grey p-150" id="demos">
      <div class="special_description_area">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="section-heading">
                <h2>Creative Demos</h2>
              </div>
              <p class="mb-5">
                Vuexy is beautifully crafted, clean & modern designed admin
                theme<br />
                with 6 different demos light, semi dark & dark versions.
              </p>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Vertical Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-7"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/default-menu.jpg"
                  alt="Apps Image"
              /></a>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Vertical Dark Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-2"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-2"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-8"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-2"
                target="_blank"
                ><img
                  class="border-grey card-hover"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/dark-layout.jpg"
                  alt="Apps Image"
              /></a>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Horizontal Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-5"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-5"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-11"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-5"
                target="_blank"
                ><img
                  class="border-grey card-hover"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/horizontal-light-menu.jpg"
                  alt="Apps Image"
              /></a>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Horizontal Dark Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-6"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-6"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-12"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-6"
                target="_blank"
                ><img
                  class="border-grey card-hover"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/horizontal-dark-menu.jpg"
                  alt="Apps Image"
              /></a>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Collapsible Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-3"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-3"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-9"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-3"
                target="_blank"
                ><img
                  class="border-grey card-hover"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/collapsible-menu.jpg"
                  alt="Apps Image"
              /></a>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center wow fadeInDown show-image card-hover"
            >
              <h5 class="mt-4 mb-4">Semi-dark Layout</h5>
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-4"
                  target="_blank"
                  >Vue.js</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-4"
                  target="_blank"
                  >Vue + Laravel</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-10"
                  target="_blank"
                  >RTL</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-4"
                target="_blank"
                ><img
                  class="border-grey card-hover"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/semi-dark-menu.jpg"
                  alt="Apps Image"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Demos End ***** -->
    <!-- ***** Package contents ***** -->
    <!-- <section class="package text-center p-5 bg-primary">
      <div class="package">
        <h5 class="m-0 text-white">
          See the package contents here:
          <a
            class="btn submit-btn package-button ml-3"
            href="https://www.pixinvent.com/demo/vuexy-tree-view/"
            target="_blank"
            ><span>Explore</span></a
          >
        </h5>
      </div>
    </section> -->
    <!-- ***** Package contents End ***** -->
    <!-- ***** Awesome Features Start ***** -->
    <!-- <section
      class="awesome-feature-area bg-grey-darken section_padding_0_50 p-150 clearfix"
      id="features"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            <div class="section-heading">
              <h2>Unique Features</h2>
            </div>
            <p class="mt-4">
              We have created developer friendly, minimal, clean, highly
              customizable admin template<br />
              which helps you to kick start your next projects/apps.
            </p>
          </div>
        </div>
        <div class="row bg-white mt-5 border-radius-15 shadow-1 py-4">
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-layout text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>VueJS + Laravel</h5>
                  <p class="text-sm">
                    Laravel & Vuejs: A Miraculous Combination for Perfect Web
                    Applications & Full-Stack Development
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-lock text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Firebase, Auth0 & JWT Authentication</h5>
                  <p class="text-sm">
                    Ready to use authentication with Firebase, social media
                    platforms, Auth0 & JWT authentication.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-search text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Algolia Integration</h5>
                  <p class="text-sm">
                    Algolia helps businesses across industries quickly create
                    relevant, scalable, and lightning fast search and discovery
                    experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-na text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>No jQuery Dependency</h5>
                  <p class="text-sm">
                    jQuery is great JS library, But It's not a great idea to use
                    jQuery and Vue.js in the same UI.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-paint-bucket text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Clean & Modern Design</h5>
                  <p class="text-sm">
                    Beautifully crafted, clean & modern designed admin theme
                    with 3 different demos & light - dark versions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-thumb-up ti-settings text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Easy Navigation</h5>
                  <p class="text-sm">
                    Carefully crafted, clean, smart & easy theme navigation with
                    collapsible option.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-search text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Quick Search</h5>
                  <p class="text-sm">
                    Easy & smart fuzzy search functionality which enables users
                    to search quickly.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-star text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>My Bookmarks</h5>
                  <p class="text-sm">
                    Bookmarks allows users to select their favorite pages/apps
                    and navigate quickly.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-direction-alt text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Dark & Light Layouts</h5>
                  <p class="text-sm">
                    Vuexy comes with built-in light and dark layouts, select as
                    per your preference.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-wand text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Built-in Customizer</h5>
                  <p class="text-sm">
                    Built-in customizer enables users to change their admin
                    panel look & feel based on their preferences.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-map-alt text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Multi Language</h5>
                  <p class="text-sm">
                    Multi language support enable you to create your
                    personalized apps in your language.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-comments text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>6 Workable Apps</h5>
                  <p class="text-sm">
                    Creative & smart workable apps like email, chat, todo &
                    calender allows you to create your apps faster.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-palette text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Colors Options</h5>
                  <p class="text-sm">
                    Unlimited color options allows you to set your application
                    color as per your branding.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-control-shuffle text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Code Splitting</h5>
                  <p class="text-sm">
                    To avoid winding up with a large bundle, it’s good to get
                    ahead of the problem and use "Code Splitting".
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature px-4 pt-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-control-forward text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Lazy Loading</h5>
                  <p class="text-sm">
                    It's more efficient to split each route's components into a
                    separate chunk, and only load them when the route is
                    visited.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-cloud-up text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Continuous Updates</h5>
                  <p class="text-sm">
                    Lifetime updates with new demos and features is guaranteed
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-check-box text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Quality Code</h5>
                  <p class="text-sm">
                    We follow the best industry code structure that all
                    developers will be able to pick up easily and fall in love
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 p-0">
            <div class="single-feature p-4">
              <div class="row">
                <div class="col-lg-3 col-12 text-right text-gradient">
                  <span class="ti-headphone-alt text-medium"></span>
                </div>
                <div class="col-lg-9 col-12">
                  <h5>Support</h5>
                  <p class="text-sm">
                    Get access to premium customer support from the actual
                    people who have created.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Awesome Features End ***** -->
    <!-- ***** Applications ***** -->
    <!-- <section class="bg-white p-150" id="applications">
      <div class="special_description_area">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="section-heading">
                <h2>Applications</h2>
              </div>
              <p class="mb-5">
                Vuexy Admin provides four different workable applications which
                enables you to<br />get started and build your applications
                faster.
              </p>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/todo"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/apps/todo"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/todo"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/app-todo.jpg"
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0"><span class="ti-check"></span> Todo</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/chat"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/apps/chat"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/chat"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/app-chat.jpg"
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0"><span class="ti-comment"></span> Chat</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/email"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/apps/email"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/email"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/app-mail.jpg"
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0"><span class="ti-email"></span> Email</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/ecommerce/shop"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/apps/ecommerce/shop"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/ecommerce/shop"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/app-ecommerce.jpg"
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0">
                <span class="ti-shopping-cart"></span> eCommerce
              </h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/calendar/vue-simple-calendar"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/apps/calendar/vue-simple-calendar"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/apps/calendar/vue-simple-calendar"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/app-calendar.jpg"
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0">
                <span class="ti-calendar"></span> Calendar
              </h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-4 text-center image-hover wow fadeInDown mt-5"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/ui-elements/data-list/thumb-view"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/ui-elements/data-list/thumb-view"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/ui-elements/data-list/thumb-view"
                target="_blank"
                ><img
                  class="border-grey"
                  src=""
                  alt="Apps Image"
              /></a>
              <h5 class="mt-4 mb-0">
                <span class="ti-layout-list-thumb"></span> Data List
              </h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Applications End ***** -->
    <!-- ***** Cool Facts Area Start ***** -->
    <!-- <section class="cool-facts-area clearfix">
      <div class="container-fluid">
        <div class="row text-center">
         
          <div class="col-lg-3 col-6 mt-4">
            <div class="single-cool-fact wow fadeInUp" data-wow-delay="0.2s">
              <div class="counter-area">
                <h3><span class="counter">6</span></h3>
              </div>
              <div class="cool-facts-content">
                <p>Workable Apps</p>
              </div>
            </div>
          </div>
          
          <div class="col-lg-3 col-6 mt-4">
            <div class="single-cool-fact wow fadeInUp" data-wow-delay="0.6s">
              <div class="counter-area">
                <h3><span class="counter">50</span>+</h3>
              </div>
              <div class="cool-facts-content">
                <p>Components</p>
              </div>
            </div>
          </div>
          
          <div class="col-lg-3 col-6 mt-4">
            <div class="single-cool-fact wow fadeInUp" data-wow-delay="0.8s">
              <div class="counter-area">
                <h3><span class="counter">100</span>+</h3>
              </div>
              <div class="cool-facts-content">
                <p>Cards</p>
              </div>
            </div>
          </div>
          
          <div class="col-lg-3 col-6 mt-4">
            <div class="single-cool-fact wow fadeInUp" data-wow-delay="0.4s">
              <div class="counter-area">
                <h3><span class="counter">100</span>+</h3>
              </div>
              <div class="cool-facts-content">
                <p>Pages</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section> -->
    <!-- ***** Cool Facts Area End ***** -->
    <!-- ***** Advance Cards ***** -->
    <!-- <section class="bg-grey p-150" id="cards">
      <div class="special_description_area">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 text-center mb-5">
              <div class="section-heading">
                <h2>Advanced Cards</h2>
              </div>
              <p>
                Vuexy Admin provides 100+ basic & advanced cards for eCommerce,
                Analytics <br />
                Statistics, Weather, Charts, Maps and Interactive.
              </p>
            </div>
            <div class="col-12 text-center">
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/ui-elements/card/statistics"
                target="_blank"
              >
                <img
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/cards.png"
                  alt="Cards Image"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Advance Cards End ***** -->
    <!-- ***** Apps & Pages ***** -->
    <!-- <section class="bg-white p-150" id="pages">
      <div class="special_description_area">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 text-center mb-5">
              <div class="section-heading">
                <h2>Pages</h2>
              </div>
              <p>
                Vuexy Admin provides 100+ pages. It contains all the commonly
                used pages to <br />
                develop any applications which will ease the developer's
                efforts.
              </p>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-3/pages/profile"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-3/pages/profile"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-3/pages/profile"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-1.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Profile</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Profile"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/knowledge-base"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/knowledge-base"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/knowledge-base"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-2.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Knowledge Base</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Knowledge Base"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/invoice"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/invoice"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/invoice"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-8.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Invoice</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/search"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/search"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/search"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-4.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Search</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/login"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/login"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/login"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-5.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Authentication</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/error-404"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/error-404"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/error-404"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-6.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Error</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/comingsoon"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/comingsoon"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/comingsoon"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-7.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Coming Soon...</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/maintenance"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/pages/maintenance"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/pages/maintenance"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-3.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">Under Maintenance</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Under Maintenance"
              ></div>
            </div>
            <div
              class="col-lg-4 col-md-6 col-12 mt-5 text-center image-hover wow fadeInDown"
            >
              <div class="mb-4">
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/"
                  target="_blank"
                  >Vue.js Demo</a
                >
                <a
                  class="btn btn-secondary btn-sm"
                  href="https://pixinvent.com/demo/vuexy-vuejs-laravel-admin-template/demo-1/"
                  target="_blank"
                  >Vue + Laravel Demo</a
                >
              </div>
              <a
                href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/"
                target="_blank"
                ><img
                  class="border-grey"
                  src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/page-9.jpg"
                  alt="Pages Image"
              /></a>
              <h5 class="mt-4 mb-0">And More...</h5>
              <div
                class="btn-group mt-2"
                role="group"
                aria-label="Basic example"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Apps & Pages End ***** -->
    <!-- ***** Build Process ***** -->
    <!-- <section class="cool-facts-area p-150" id="build-process">
      <div class="section-heading-white text-center">
        <img
          src="https://pixinvent.com/demo/vuexy-html-bootstrap-admin-template/landing/img/scr-img/gitlab-icon.png"
          class="git-bg"
          alt="GitLab"
        />
        <h4 class="text-white mt-2">Gitlab</h4>
        <p class="text-white mt-4">
          You can join Vuexy Admin Gitlab repository to access the latest
          changes, <br />bug fixes and features without having to wait for a new
          ThemeForest release.
        </p>
        <a
          class="btn purchase-btn mt-3 px-4"
          href="https://pixinvent.com/gitlab-access-provider-for-envato"
          target="_blank"
          ><span>Join Vuexy Admin on Gitlab</span></a
        >
      </div>
    </section> -->
    <!-- ***** Build Process End ***** -->
    <!-- ***** Components ***** -->
    <!-- <section class="bg-grey p-150 pb-150" id="components">
      <div class="container-fluid">
        <div class="row text-center">
          <div class="col-12 mb-b">
            
            <div class="section-heading">
              <h2>Components</h2>
            </div>
            <p class="mb-5">
              We have used most popular Vuexy components and combined them with
              useful components. <br />
              Themed them with same UI of vuexy principles and created a perfect
              design harmony.
            </p>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/alert"
              target="_blank"
            >
              <div class="h1 ti-alert" aria-hidden="true"></div>
              <p>Alerts</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/avatar"
              target="_blank"
            >
              <div class="h1 ti-user" aria-hidden="true"></div>
              <p>Avatar</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/notifications"
              target="_blank"
            >
              <div class="h1 ti-menu-alt" aria-hidden="true"></div>
              <p>Notification</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/breadcrumb"
              target="_blank"
            >
              <div class="h1 ti-layout-menu-separated" aria-hidden="true"></div>
              <p>Breadcrumb</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/slider"
              target="_blank"
            >
              <div class="h1 ti-line-dotted" aria-hidden="true"></div>
              <p>Slider</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/collapse"
              target="_blank"
            >
              <div
                class="h1 ti-layout-accordion-merged"
                aria-hidden="true"
              ></div>
              <p>Collapse</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/button"
              target="_blank"
            >
              <div class="h1 ti-link" aria-hidden="true"></div>
              <p>Buttons</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/dropdown"
              target="_blank"
            >
              <div class="h1 ti-angle-down" aria-hidden="true"></div>
              <p>Dropdowns</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/dialogs"
              target="_blank"
            >
              <div class="h1 ti-layout" aria-hidden="true"></div>
              <p>Dialogs</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/tabs"
              target="_blank"
            >
              <div class="h1 ti-layout-tab-window" aria-hidden="true"></div>
              <p>Tabs</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/chip"
              target="_blank"
            >
              <div class="h1 ti-medall-alt" aria-hidden="true"></div>
              <p>Chip</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/progress"
              target="_blank"
            >
              <div class="h1 ti-more-alt" aria-hidden="true"></div>
              <p>Progress</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/select"
              target="_blank"
            >
              <div class="h1 ti-layout-media-left" aria-hidden="true"></div>
              <p>Select</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/ui-elements/table"
              target="_blank"
            >
              <div class="h1 ti-layout-column3" aria-hidden="true"></div>
              <p>Tables</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/forms/form-wizard"
              target="_blank"
            >
              <div class="h1 ti-layout-cta-left" aria-hidden="true"></div>
              <p>Wizard</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/forms/form-validation"
              target="_blank"
            >
              <div class="h1 ti-check" aria-hidden="true"></div>
              <p>Validation</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/divider"
              target="_blank"
            >
              <div class="h1 ti-split-v" aria-hidden="true"></div>
              <p>Divider</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/quill-editor"
              target="_blank"
            >
              <div class="h1 ti-pencil" aria-hidden="true"></div>
              <p>Editor</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/list"
              target="_blank"
            >
              <div class="h1 ti-layout-list-post" aria-hidden="true"></div>
              <p>List</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/carousel"
              target="_blank"
            >
              <div class="h1 ti-layout-sidebar-left" aria-hidden="true"></div>
              <p>Carousel</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/drag-and-drop"
              target="_blank"
            >
              <div class="h1 ti-hand-drag" aria-hidden="true"></div>
              <p>Drag &amp; Drop</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/upload"
              target="_blank"
            >
              <div class="h1 ti-export" aria-hidden="true"></div>
              <p>Upload</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/components/loading"
              target="_blank"
            >
              <div class="h1 ti-reload" aria-hidden="true"></div>
              <p>Spinners</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/dashboard/analytics"
              target="_blank"
            >
              <div class="h1 ti-direction" aria-hidden="true"></div>
              <p>Tour</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/clipboard"
              target="_blank"
            >
              <div class="h1 ti-notepad" aria-hidden="true"></div>
              <p>Clipboard</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/extensions/context-menu"
              target="_blank"
            >
              <div class="h1 ti-menu" aria-hidden="true"></div>
              <p>Context Menu</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/charts-and-maps/charts/apex-charts"
              target="_blank"
            >
              <div class="h1 ti-bar-chart" aria-hidden="true"></div>
              <p>Charts</p>
            </a>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mt-40 icon-hover">
            <a
              href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/charts-and-maps/maps/google-map"
              target="_blank"
            >
              <div class="h1 ti-map" aria-hidden="true"></div>
              <p>Map</p>
            </a>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** Components End ***** -->
    <!-- ***** FAQ Start ***** -->
    <!-- <section
      class="app-screenshots-area bg-white section_padding_0_100 clearfix p-150"
      id="faq"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            
            <div class="section-heading">
              <h2>FAQ</h2>
            </div>
            <p class="mt-5">
              Got a question? We've got answers. If you have some other
              questions, see our
              <a href="https://pixinvent.ticksy.com/" target="_blank"
                >support center.</a
              >
            </p>
          </div>
        </div>
        <div class="row mt-5">
          <div class="accordion" id="accordionExample">
            <div class="card border-radius-15 mb-2">
              <div
                class="card-header border-radius-15 border-radius-15"
                id="headingOne"
              >
                <h5 class="mb-0">
                  <button
                    class="btn btn-link"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Do you charge for each upgrade?
                  </button>
                </h5>
              </div>
              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p class="text-sm">
                    Not at all. Once you purchase a license, you'll receive all
                    future releases for free.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-radius-15 mb-2">
              <div class="card-header border-radius-15" id="headingTwo">
                <h5 class="mb-0">
                  <button
                    class="btn btn-link collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Do I need to purchase a license for each website?
                  </button>
                </h5>
              </div>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p class="text-sm">
                    Yes, you need to have a separate license for each website.
                    You might need to purchase extended license for your web
                    application.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-radius-15 mb-2">
              <div class="card-header border-radius-15" id="headingThree">
                <h5 class="mb-0">
                  <button
                    class="btn btn-link collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    What is regular license?
                  </button>
                </h5>
              </div>
              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p class="text-sm">
                    Regular license can be used for end products that do not
                    charge users for access or service(access is free and there
                    will be no monthly subscription fee). Single regular license
                    can be used for single end product and end product can be
                    used by you or your client. If you want to sell end product
                    to multiple clients then you will need to purchase separate
                    license for each client. The same rule applies if you want
                    to use the same end product on multiple domains(unique
                    setup). For more info on regular license you can check
                    official description.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-radius-15 mb-2">
              <div class="card-header border-radius-15" id="headingFour">
                <h5 class="mb-0">
                  <button
                    class="btn btn-link collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    What is extended license?
                  </button>
                </h5>
              </div>
              <div
                id="collapseFour"
                class="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p class="text-sm">
                    Extended license can be used for end products(web service or
                    SAAS) that charges users for access or service(e.g: monthly
                    subscription fee). Single extended license can be used for
                    single end product and end product can be used by you or
                    your client. If you want to sell end product to multiple
                    clients then you will need to purchase separate extended
                    license for each client. The same rule applies if you want
                    to use the same end product on multiple domains(unique
                    setup). For more info on extended licenses you can check
                    official description.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-radius-15 mb-2">
              <div class="card-header border-radius-15" id="headingFive">
                <h5 class="mb-0">
                  <button
                    class="btn btn-link collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Which license is applicable for SASS application?
                  </button>
                </h5>
              </div>
              <div
                id="collapseFive"
                class="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p class="text-sm">
                    If you are charging your customer for using your SASS based
                    application you must buy an Extended License for each end
                    product. If you aren't charging your customer then purchase
                    Regular License for each end product.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- ***** FAQ End *****====== -->
    <!-- ***** Pricing Plane Area Start *****==== -->
    <!-- <section class="pricing-plane-area bg-grey p-50 clearfix" id="pricing">
      <div class="row">
        <div class="offset-lg-1"></div>
        <div class="col-12 col-lg-5 col-mg-6 full-xl wow fadeIn p-0">
          <div class="container-fluid gradient-primary p-5 mb-4">
            <h3 class="text-white">Regular License</h3>
            <hr class="hr-width" />

            <p class="text-offwhite">
              Use by you or your one client in a single end product which
              <b class="text-white">end users are not charged.</b>
            </p>
            <p class="text-offwhite m-1">
              <span class="ti-check mr-1"></span>6 Months Premium Support
              Included
            </p>
            <p class="text-offwhite m-1">
              <span class="ti-check mr-1"></span>Pricing includes all the taxes
            </p>
            <p class="text-offwhite">
              <span class="ti-check mr-1"></span>Lifetime Free Updates
            </p>
            <h4 class="text-big text-white">Only $32 NOW</h4>
            <a
              class="btn purchase-btn mt-3"
              href="https://1.envato.market/vuexy_admin"
              target="_blank"
              ><span>Purchase Now</span></a
            >
          </div>
        </div>
        <div class="col-12 col-lg-5 col-mg-6 full-xl wow fadeIn p-0">
          <div class="container-fluid gradient-primary p-5 mb-4">
            <h3 class="text-white">Extended License</h3>
            <hr class="hr-width" />

            <p class="text-offwhite">
              Use by you or your one client in a single end products which
              <b class="text-white">end users can be charged</b>.
            </p>
            <p class="text-offwhite m-1">
              <span class="ti-check mr-1"></span>6 Months Premium Support
              Included
            </p>
            <p class="text-offwhite m-1">
              <span class="ti-check mr-1"></span>Pricing includes all the taxes
            </p>
            <p class="text-offwhite">
              <span class="ti-check mr-1"></span>Lifetime Free Updates
            </p>
            <h4 class="text-big text-white">Only $799 NOW</h4>
            <a
              class="btn purchase-btn mt-3"
              href="https://1.envato.market/vuexy_admin"
              target="_blank"
              ><span>Purchase Now</span></a
            >
          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </section> -->
  </div>
</template>

<script>
import Logo from "../../../layouts/components/Logo";
export default {
  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // console.log(currentScrollPosition)
      // if(currentScrollPosition==0){
      //   this.class_update=false
      // }
      // else{
      //   this.class_update=true
      // }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
  },
  created() {},
  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
/* --------------------------
:: Template Name: Vuexy App - App Landing Page
:: Template Author: Vuexy
:: Template Author URI: https://pixinvent.com/
-------------------------- */

@import url("https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700");
@import "../../../assets/css/bootstrap.min.css";
@import "../../../assets/css/animate.css";
@import "../../../assets/css/themify-icons.css";

/* --------------------------
:: 1.0 Base CSS Start
-------------------------- */

* {
  margin: 0;
  padding: 0;
  -webkit-max-width: 100% !important;
  max-width: 100% !important;
}

_::-webkit-full-page-media,
_:future,
* {
  max-width: 100% !important;
}
span.no-bold {
  font-weight: 300;
}
h1.color-white {
  color: #fff;
  font-weight: 700;
}
.dhp-ul {
  color: #655af3;
  li {
    list-style: disc;
    margin-left: 25px;
  }
}
.wellcome-heading {
    margin-top: 25%;
}
.dhp_logo {
  margin-bottom: 90px;
  margin-top: 80px;
}
.app-link {
  /* display: block !important; */
  position: absolute;
  bottom: 0;
  img{
    margin-left: 6px;
  }
}
body {
  font-family: "Montserrat", sans-serif;
  background-color: #fff;
  color: #343c55;
  max-width: 100% !important;
  overflow-x: hidden !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  color: #343c55;
  line-height: 1.4;
  letter-spacing: 0.03rem;
}

img {
  max-width: 100%;
  max-height: 100%;
}

a {
  color: #b053ed;
}

.font-100 {
  font-weight: 100;
}

.font-900 {
  font-weight: 900;
}

.image-hover a img {
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  border-radius: 10px;
  width: 90%;
}

.icon-hover div {
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  color: #c5c5c5;
}

.icon-hover:hover div {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
  color: #b053ed !important;
}

.mt-15 {
  margin-top: 15px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-50 {
  margin-top: 50px;
}

.mt-100 {
  margin-top: 100px;
}

.mt-150 {
  margin-top: 150px;
}

.mr-15 {
  margin-right: 15px;
}

.mr-30 {
  margin-right: 30px;
}

.mr-50 {
  margin-right: 50px;
}

.mr-100 {
  margin-right: 100px;
}

.mb-10 {
  margin-bottom: 10%;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-100 {
  margin-bottom: 100px;
}

.ml-15 {
  margin-left: 15px;
}

.ml-30 {
  margin-left: 30px;
}

.ml-50 {
  margin-left: 50px;
}

.ml-100 {
  margin-left: 100px;
}

.p-150 {
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.p-50 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.pb-150 {
  padding-bottom: 150px;
}

.w-4 {
  width: 2.5rem;
}

.w-5 {
  width: 3.8rem;
}

.text-big {
  font-size: 2.5rem;
  text-shadow: -2px 2px 6px #1c1486ba;
}

.text-medium {
  font-size: 2.5rem;
}

.text-bold {
  font-weight: 400;
  color: #3a3a3a;
}

.text-gradient {
  color: #655af3;
  padding-top: 8px;
}

.bg-primary {
  background-color: #655af3 !important;
}

.bg-grey {
  background-color: #0000000a !important;
}

.bg-grey-darken {
  background-color: #00000004 !important;
}

.gradient-primary {
  background-color: #655af3;
  border-radius: 0.6rem;
}

.text-opacity {
  opacity: 0.8;
}

.shadow-1 {
  box-shadow: 0px 0px 10px 2px #0001;
}

.opacity-4 {
  opacity: 0.25;
}

ul,
ol {
  margin: 0;
  padding: 0;
}

#scrollUp {
  bottom: 0;
  font-size: 24px;
  width: 50px;
  background-color: #ff4961;
  color: #fff;
  text-align: center;
  height: 50px;
  line-height: 50px;
}

a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  -webkit-transition-duration: 500ms;
  -o-transition-duration: 500ms;
  transition-duration: 500ms;
  cursor: pointer !important;
}

li {
  list-style: none;
}

p {
  color: #726a84;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.2px;
  margin-top: 0;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.vx-row {
  margin: 0px;
}

.hr-width {
  width: 50%;
}

.heading-text > p {
  font-size: 16px;
}

.section-heading > h2 {
  font-weight: 400;
  color: #655af3;
  font-size: 38px;
  margin: 0;
  margin-bottom: 25px;
}

.section-heading-white > h2 {
  font-weight: 300;
  color: #fff;
  font-size: 38px;
  margin: 0;
}

.section-heading-white {
  margin-bottom: 60px;
}

.section-heading {
  margin-bottom: 10px;
}

.line-shape-white {
  width: 80px;
  height: 2px;
  background-color: #fff;
  margin-top: 15px;
}

.line-shape {
  width: 80px;
  height: 2px;
  background-color: #ff4961;
  margin-top: 15px;
}

.line-shape-white,
.line-shape {
  margin-left: calc(50% - 40px);
}

.table {
  display: table;
  height: 100%;
  left: 0;
  position: relative;
  top: 0;
  width: 100%;
  z-index: 2;
}

.table-cell {
  display: table-cell;
  vertical-align: middle;
}

#preloader {
  overflow: hidden;
  background-color: #fff;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999999;
}

.container-fluid {
  width: 90% !important;
  margin: auto;
}

.border-grey {
  border: 1px solid #e7e7e7;
  border-radius: 0.6rem;
}

.navbar-light .navbar-toggler {
  background-color: #fff;
}

.logo-width {
  width: 50px;
  margin-right: 5px;
}

.logo-font {
  font-weight: 600;
}

.git-bg {
  background-color: #fff;
  padding: 10px;
  border-radius: 100px;
  width: 75px;
  height: 75px;
  box-shadow: 4px 4px 30px #0009;
}

.border-radius-15 {
  border-radius: 15px !important;
}

.text-offwhite {
  color: #dad7ff;
}

/* --------------------------
:: 2.0 Header Area CSS
-------------------------- */

.header_area {
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 99;
  top: 0;
  padding: 0 4%;
}

.menu_area .navbar-brand {
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1;
  padding: 0;
}

.menu_area .navbar-brand:hover,
.menu_area .navbar-brand:focus {
  color: #fff;
}
@media (max-width: 621px) {
.app-link img{
  width: 40%;
}
h1.color-white{
  font-size: 28px;
}
.wellcome-heading{
  margin-top: 24% !important;
}
}

@media (max-width: 991px) {
  .header_area.sticky {
    height: 65px !important;
  }
  .wellcome-heading {
    justify-content: center;
    display: grid;
}
.dhp_logo{
  width: 40%;
}
}






.menu_area {
  position: relative;
  z-index: 2;
}

.menu_area #nav .nav-link {
  cursor: pointer;
  color: #fff;
  display: block;
  font-size: 16px;
  border-radius: 30px;
  -webkit-transition-duration: 500ms;
  -o-transition-duration: 500ms;
  transition-duration: 500ms;
  padding: 6px 6px;
  letter-spacing: 1px;
}

.menu_area nav ul li > a:hover {
  color: #ff4961;
}

.btn-link {
  color: #655af3;
}

.btn-link:hover {
  color: #655af3;
}

.btn-info {
  color: #fff;
  background-color: #7064f5;
  border: #7064f5;
}

.btn-info:hover {
  background-color: #7064f5;
  border: #7064f5;
}

.btn-danger {
  background-color: #ea5455;
  border-radius: 5rem;
}

.btn-secondary {
  background-color: #6358ed !important;
  border-color: #867cff !important;
  color: #fff;
}

.btn-secondary:active {
  background-color: #4e43d0 !important;
}

.btn-secondary:hover {
  background-color: #4e43d0 !important;
  color: none;
  border: 1px solid #4e43d0 !important;
}

.btn-secondary:focus {
  box-shadow: none !important;
}

.btn {
  cursor: pointer;
}

.btn-group > .btn {
  border-radius: 10rem;
  padding-left: 20px;
  padding-right: 20px;
  display: block;
  color: #fff;
  background-color: #6358ed !important;
  border-color: #867cff !important;
}

.btn-group > .btn:hover {
  border-radius: 10rem;
  padding-left: 20px;
  padding-right: 20px;
  display: block;
  color: #fff;
  background-color: #5348d6 !important;
  border-color: #687498 !important;
}

.demo-btn {
  background-color: #fff;
  padding: 6px 18px 6px 18px;
  box-shadow: -4px 4px 15px 0px #00000050;
  color: #655af3;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  font-weight: 600;
}

.demo-btn:hover {
  background-color: #fff;
  color: #655af3;
  box-shadow: -4px 4px 15px 0px #00000050;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  font-weight: 600;
}

.demo-btn-light {
  padding: 6px 18px 6px 18px;
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  font-weight: 600;
}

.demo-btn-light:hover {
  /*background-color: #fff;*/
  color: #fff;
  box-shadow: -4px 4px 15px 0px #00000050;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  font-weight: 600;
}

.buynow-btn {
  background-color: #ffa84c;
  box-shadow: 0px 5px 30px 0px #00000080;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  width: fit-content;
  margin: auto;
}

.buynow-btn:hover {
  background-color: #ffa84c;
  box-shadow: 0px 4px 20px 0px #00000080;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.buynow-btn a {
  color: #fff !important;
}

.purchase-btn {
  background-color: #ffa84c;
  box-shadow: 0px 5px 30px 0px #00000080;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  width: fit-content;
  color: #fff;
  padding: 1rem;
  padding-top: 10px;
  padding-bottom: 10px;
}

.purchase-btn:hover {
  background-color: #ec973d;
  box-shadow: 0px 4px 20px 0px #00000080;
  color: #fff;
}

.accordion {
  width: 100%;
  overflow: hidden;
}

#container1 {
  width: 100%;
  max-width: 1024px;
}

/* stcicky css */

.header_area.sticky {
  background-color: #655af3;
  box-shadow: 0px 4px 25px 0px #00000050;
  height: 75px;
  padding-top: 2px;
  position: fixed;
  top: 0;
  z-index: 99;
}

.header_area.sticky .menu_area .navbar-brand {
  font-size: 50px;
}

.header_area.sticky .navbar {
  padding: 0;
  margin-top: 9px;
}
.navbar.navbar--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}
.sticky .logo-font {
  color: #fff;
}

/* --------------------------
:: 3.0 Wellcome Area CSS
-------------------------- */

.wellcome_area {
  background-image: url("https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/landing/img/bg-img/bg.png");
  height: 100vh;
  position: relative;
  z-index: 1;
  background-position: bottom center;
  background-size: cover;
}

.wellcome_area:after {
  width: 100%;
  left: 0;
  height: 2px;
  background-color: #fff;
  content: "";
  bottom: 0;
  z-index: 2;
}

.welcome-thumb {
  z-index: 9;
}

.welcome-thumb img {
  margin-top: 5%;
  margin-left: 10%;
  border-radius: 1rem;
  height: auto;
  width: 100%;
  -webkit-box-shadow: 0px 0px 40px 18px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 40px 18px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 40px 18px rgba(0, 0, 0, 0.1);
}

.wellcome-heading > h2 {
  font-size: 30px;
  color: #655af3;
  font-weight: 700;
  position: relative;
  z-index: 3;
}

.get-start-area .email {
  background: #9572e8;
  height: 50px;
  max-width: 260px;
  border: none;
  border-radius: 24px;
  padding: 0px 15px;
}

.form-control::-webkit-input-placeholder {
  color: #cec1f4;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #cec1f4;
  opacity: 1;
}

.form-control::-ms-input-placeholder {
  color: #cec1f4;
  opacity: 1;
}

.form-control::placeholder {
  color: #cec1f4;
  opacity: 1;
}

.get-start-area .email:focus {
  border: none;
  outline-offset: transparent !important;
  border-radius: 30px;
}

.get-start-area .submit {
  background-color: #ff4961;
  color: #fff;
  font-weight: 500;
  display: inline-block;
  border: none;
  height: 50px;
  min-width: 167px;
  line-height: 46px;
  text-align: center;
  border-radius: 24px 24px 24px 24px;
  margin-left: 10px;
}

.get-start-area .submit:hover {
  background: #6f52e5;
  color: #fff;
  -webkit-transition-duration: 500ms;
  -o-transition-duration: 500ms;
  transition-duration: 500ms;
}

.wellcome-heading > h3 {
  font-size: 332px;
  position: absolute;
  top: -134px;
  font-weight: 900;
  left: -12px;
  z-index: -1;
  color: #fff;
  opacity: 0.1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=10)";
}

@media (max-width: 767px) {
  .wellcome-heading > h2 {
    font-size: 30px !important;
  }
  .package-button {
    margin-top: 1rem;
  }
}

.card-hover img {
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 25px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 4px 25px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  width: 90%;
}

.card-header {
  margin-bottom: -1px;
  background-color: rgba(0, 0, 0, 0.01);
}

.text-sm {
  font-size: 16px;
}

@media (min-width: 1680px) {
  .wellcome-heading > h2 {
    font-size: 30px;
  }

  .sub-font-lg {
    font-size: 22px;
  }
}

@media (min-width: 1419px) and (min-width: 1680px) {
  .wellcome-heading > h2 {
    font-size: 30px;
  }
}

@media (max-width: 1024px) {
  .wellcome-heading > h2 {
    font-size: 30px;
  }

  .logo-font {
    // display: none;
  }

  .welcome-thumb img {
    margin-left: 0%;
  }

  .single-feature {
    text-align: center;
  }

  .single-feature .text-right {
    text-align: center !important;
    margin-bottom: 1rem;
  }
}

.cd-resize-img img {
  max-width: none !important;
}

/* --------------------------
:: 4.0 Special Area CSS
-------------------------- */

.single-icon > i {
  font-size: 36px;
  color: #ff4961;
}

.single-special > h4 {
  font-size: 22px;
  color: #1e9ff2;
}

.single-icon {
  margin-bottom: 25px;
}

.single-special > h4 {
  font-size: 22px;
  color: #1e9ff2;
  margin-bottom: 15px;
}

.single-special {
  border: 1px solid #eff2f6;
  padding: 40px;
  border-radius: 40px 40px 40px 0px;
  -webkit-transition-duration: 800ms;
  -o-transition-duration: 800ms;
  transition-duration: 800ms;
  margin-bottom: 30px;
}

.special_description_content > h2 {
  color: #1e9ff2;
  font-size: 48px;
  margin-bottom: 30px;
}

.single-special:hover {
  -webkit-box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
}

.single-special p {
  margin-bottom: 0;
}

.app-download-area {
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 1;
  flex-basis: 1;
  margin-top: 50px;
}

.app-download-btn a {
  border: 1px solid #ddd;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px 30px;
  border-radius: 30px 30px 30px 0;
  -webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.app-download-btn.active a,
.app-download-btn a:hover {
  border-color: transparent;
  background-color: #ff4961;
}

.app-download-btn a i {
  color: #47425d;
  font-size: 24px;
  margin-right: 15px;
  -webkit-transition-duration: 500ms;
  -o-transition-duration: 500ms;
  transition-duration: 500ms;
}

.app-download-btn a p {
  font-size: 16px;
  line-height: 1;
  -webkit-transition-duration: 500ms;
  -o-transition-duration: 500ms;
  transition-duration: 500ms;
}

.app-download-btn a p span {
  font-size: 12px;
  display: block;
}

.app-download-btn:first-child {
  margin-right: 20px;
}

.app-download-btn a:hover i,
.app-download-btn.active a i,
.app-download-btn.active a p,
.app-download-btn a:hover p {
  color: #fff;
}

/* --------------------------
:: 5.0 Features Area CSS
-------------------------- */

.single-feature > p {
  margin-bottom: 0;
}

.single-feature > i {
  color: #ff4961;
  font-size: 30px;
  display: inline-block;
  float: left;
  margin-right: 10px;
}

.single-feature > h5 {
  font-size: 22px;
  color: #b053ed;
}

.single-feature > p {
  margin-top: 15px;
}

/* --------------------------
:: 6.0 Cool Facts Area CSS
-------------------------- */

.cool-facts-area {
  position: relative;
  z-index: auto;
  background-color: #655af3;
  padding: 80px 0 80px 0;
}

.cool-facts-content > i {
  color: #ffffff;
  font-size: 36px;
}

.counter-area {
  min-width: 100px;
  -ms-flex-item-align: end;
  align-self: flex-end;
}

.counter-area > h3 {
  color: #ffffff;
  font-size: 60px;
  margin-bottom: 0;
  line-height: 1;
}

.cool-facts-content > p {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 0;
}

.tooltip-inner {
  background-color: #12153b !important;
  color: #fff;
  font-size: 1rem;
}

.bs-tooltip-top .arvx-row::before {
  border-width: 0.53rem 0.535rem 0;
  border-top-color: #12153b !important;
}

/* --------------------------
:: 7.0 Button
-------------------------- */
.btn.submit-btn {
  background-color: #ffb255;
  box-shadow: 0px 5px 30px 0px #efa23e9c;
  height: 46px;
  min-width: 165px;
  color: #ffffff !important;
  font-weight: 900;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  padding-top: 9px;
}

.btn.submit-btn:hover {
  background-color: #eca34a;
  box-shadow: 0px 4px 20px 0px #ffba5f73;
}

/* Buy Button */

.btn.buy-btn {
  background-color: #7064f5;
  box-shadow: 0px 5px 30px 0px #7b6ff67a;
  height: 46px;
  min-width: 165px;
  color: #ffffff !important;
  font-weight: 900;
  border-radius: 50px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  padding-top: 9px;
}

.btn.buy-btn:hover {
  background-color: #5c50d8;
  box-shadow: 0px 4px 20px 0px #6f64e270;
}

/* Hire Us */

.btn.hire-us {
  background-color: #4ca1f6;
  box-shadow: 0px 4px 20px 0px #3b395061;
  height: 50px;
  min-width: 165px;
  color: #ffffff !important;
  font-weight: 900;
  border-radius: 6px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  padding-top: 11px;
  position: fixed;
  margin-top: -86px !important;
  float: right;
  right: 7rem;
}

.btn.hire-us:hover {
  background-color: #3a87d3;
  box-shadow: 0px 4px 20px 0px #3b395061;
}

.navbar-collapse {
  min-height: 44px !important;
  overflow: visible;
}

.heading-bg p {
  color: #ffffff;
  background-color: #ffffff33;
  border-radius: 50px;
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding: 0.4rem;
  max-width: 20rem !important;
  margin-left: auto;
  margin-right: auto;
}

/* ----------------
:: 9.0 Media Query
------------------ */

@media only screen and (max-width: 1200px) {
  .align-items-center {
    text-align: center;
  }
  h1.color-white {
    color: #5c50d8;
  }

  .w-m-100 {
    min-width: 100%;
  }
  .dhp_logo{
  width: 40%;
}

  .full-xl {
    flex: 100%;
    margin-top: 3rem;
  }

  .wellcome_area {
    background-image: none;
    margin-top: 4rem;
    height: 100%;
    margin-bottom: 4rem;
  }

  .heading-bg p {
    background-color: #7064f5;
  }

  .demo-btn-light {
    background-color: #f4f4f4;
    color: #7064f5;
  }
  .demo-btn-light:hover {
    color: #7064f5;
  }
}

@media only screen and (max-width: 468px) {
  .btn.submit-btn {
    margin-top: 10px;
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .welcome-thumb {
    width: 100% !important;
  }
}

@media only screen and (max-width: 1200px) {
  .image-comparison {
    display: none;
  }

  .wellcome-heading {
    margin-top: 25%;
  }

  .wellcome_area {
    background-image: none;
    margin: 0 !important;
  }

  .w-m-100 {
    min-width: 100%;
  }

  .navbar-collapse {
    // background-color: #655af3;
    // padding: 2rem;
    // border-radius: 1rem;
    // margin-top: 1rem;
    // overflow: hidden;
    ul{
    float: right;

    }
  }
  h4.logo-font.mt-2.ml-1 {
    width: 100%;
    text-align: left;
}
  .text-big {
    font-size: 2.5rem;
  }
}

/* ----------------
:: 10.0 Headroom
------------------ */

.headroom {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  right: 0;
  /* -webkit-transition: .25s -o-transition: .25s -moz-transition: .25s -ms-transition: .25s transition: transform .25s ease-in-out; */
}

.headroom--unpinned {
  top: -108px;
  -webkit-transition: 0.25s;
  -o-transition: 0.25s;
  -moz-transition: 0.25s;
  -ms-transition: 0.25s;
  transition: 0.25s;
  -webkit-transform: translateY(-108px);
  -o-transform: translateY(-108px);
  -moz-transform: translateY(-108px);
  -ms-transform: translateY(-108px);
  transform: translateY(-108px);
}

.headroom--pinned {
  top: 0;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  -moz-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}

/* ----------------
:: 11.0 Image Hover
------------------ */

button {
  cursor: pointer;
}

.btn-light {
  background-color: #eff1f3 !important;
}

div.show-image {
  position: relative;
  float: left;
}

div.show-image:hover img {
  -webkit-transition: 1s;
  /* Safari */
  transition: 1s;
}

.ltr {
  border-radius: 50px;
  top: 35%;
  left: 18%;
  padding: 8px;
  background-color: #ff4961;
  opacity: 1;
  padding-left: 25px;
  padding-right: 25px;
  border: 1px solid #ff4961;
  color: #fff;
  z-index: 1;
}

.ltr:hover {
  color: #fff;
  background-color: #ef344d;
}

.rtl {
  border-radius: 50px;
  top: 35%;
  left: 18%;
  padding: 8px;
  background-color: #ff4961;
  opacity: 1;
  padding-left: 25px;
  padding-right: 25px;
  border: 1px solid #ff4961;
  color: #fff;
  z-index: 1;
}

.rtl:hover {
  color: #fff;
  background-color: #ef344d;
}

.text-danger {
  color: #7064f5 !important;
}

/* Carousel */

.carousel-indicators {
  bottom: -20px;
}
</style>